import { Card, Col, Form, Input, Layout, Row, Select, Switch, TreeSelect } from 'antd';
import { includes, toNumber } from 'lodash';
import { useEffect, useMemo, useReducer, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import FormActionButton from 'src/components/common/FormActionButton';
import { messages } from 'src/constants/messages';
import { apiCaller, cancelListToken } from 'src/util/apiCaller';
import { MessageStatusError } from 'src/util/MessageStatus';

const FormItem = Form.Item;

const listCap = [
  { cap: 1, name: "Sở Ban Ngành" },
  { cap: 2, name: "Ngành dọc" },
  { cap: 3, name: "Huyện" },
  { cap: 4, name: "Xã" },
];

const initialState = {
  tenDonVi: "",
  isDonVi: false,
  maDinhDanh: "",
  thuTu: "",
  loaiDonVi: "",
  parentId: 0,
};

const PhongBanTableForm = ({ status }: any) => {
  const { isActive } = status;
  const navigate = useNavigate();
  const [fieldTouch, setFieldTouch] = useState(false);
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingButtonClose, setLoadingButtonClose] = useState(false);
  const [form] = Form.useForm();
  const { tenDonVi, isDonVi, thuTu, maDinhDanh } = initialState;
  const [cap, setCap] = useState(1);
  const [type, setType] = useState("new");
  const { id } = useParams();
  const location = useLocation();
  const [parentId, setParentId] = useState(undefined);
  const [treeDataPB, setTreeDataPB] = useState();

  const { validateFields, resetFields, setFieldsValue } = form;

  useEffect(() => {
    if (isActive) {
      const load = () => {
        if (includes(location.pathname, "them-moi")) {
          setType("new");
        } else {
          setType("edit");
          getInfo();
        }
      };
      getListData();
      load();
    } else {
      navigate("/error/401");
    }
  }, []);

  useEffect(() => {
    return () => {
      cancelListToken(["infophongban"]);
    };
  }, []);

  
  /**
   * getListData : Lấy danh sách phòng ban
   * @memberof  PhongBanForm
   */
  const getListData = async () => {
    const configAPI = {
      url: "api/phongbans/gettreealluser",
      method: "GET",
      value: "",
      apiType: "DETAIL",
      getName: "gettreealluser",
    };
    const response = await apiCaller(configAPI);
    try {
      if (
        response?.data &&
        (response.status === 200 || response.status === 201)
      ) {
        setTreeDataPB(response.data);
      } else {
        MessageStatusError(toNumber(response?.status));
      }
    } catch (error) {
      error;

      // Xử lý lỗi khi lưu dữ liệu không thành công
    }
  };

  /**
   * getInfo : Lấy thông tin
   * @memberof  phongbanForm
   */
  const getInfo = async () => {
    if (location.state && location.state.itemData) {
      // Nếu có dữ liệu truyền sang
      const res = location.state.itemData;
      setFieldsValue({
        phongban: res,
      });
    } else {
      const configAPI = {
        url: `api/phongbans/${id}`,
        method: "GET",
        value: "",
        apiType: "DETAIL",
        getName: "infophongban",
      };
      const response = await apiCaller(configAPI);
      try {
        if (
          response?.data &&
          (response.status === 200 || response.status === 201)
        ) {
          setFieldsValue({
            phongban: response.data,
          });
        } else {
          MessageStatusError(toNumber(response?.status));
        }
      } catch (error) {
        // Xử lý lỗi khi lưu dữ liệu không thành công
      }
    }
  };

  /**
   * treeDataSelect: Vòng lặp tìm treeData
   * @memberof PhongBanForm
   */
  const treeDataSelect = useMemo(() => {
    const loop = (data: any) =>
      data?.map((item: any) => {
        if (item.children) {
          return {
            title: item.tenDonVi,
            value: item.id,
            key: item.id,
            children: loop(item.children),
          };
        }
        return {
          title: item.tenDonVi,
          value: item.id,
          key: item.id,
        };
      });
    return loop(treeDataPB);
  }, [treeDataPB]);

  /**
   * goBack : quay lại trang danh sách
   * @memberof  PhongBanForm
   */
  const goBack = () => {
    navigate("/quan-tri/phong-ban-table");
  };

  /**
   * save : lưu dữu liệu
   * @memberof  PhongBanForm
   */
  const save = () => {
    validateFields()
      .then((values) => {
        setLoadingButton(true);
        saveData(values, false);
      })
      .catch(() => {
        setLoadingButton(false);
      });
  };

  /**
   * saveAndClose: Lưu và đóng
   * @memberof PhongBanForm
   */
  const saveAndClose = () => {
    validateFields()
      .then((values) => {
        setLoadingButton(true);
        saveData(values, true);
      })
      .catch(() => {
        setLoadingButton(false);
      });
  };

  /**
   * saveData : lưu dữu liệu
   * @memberof  PhongBanForm
   */
  const saveData = async (values: any, saveQuit = false) => {
    console.log('values', values)
    const newData = { ...values.phongban };
    newData.level = cap;
    newData.loaiDonVi = cap;
    newData.isSuDung = true;
    try {
      let configAPI;
      if (type === "new") {
        configAPI = {
          url: `api/phongbans/create`,
          method: "POST",
          data: newData,
          apiType: "ADD",
          isShowMessage: true,
        };
      } else {
        configAPI = {
          url: `api/phongbans/${id}`,
          method: "PUT",
          data: newData,
          apiType: "EDIT",
          isShowMessage: true,
        };
      }

      const response = await apiCaller(configAPI);
      if (response?.status === 200 || response?.status === 201) {
        if (saveQuit) {
          goBack();
          setLoadingButtonClose(false);
        } else {
          if (type === "new") {
            resetFields();
          }
          setFieldTouch(false);
          setLoadingButton(false);
        }
      } else {
        MessageStatusError(toNumber(response?.status));
        setLoadingButton(false);
      }
    } catch (error) {
      setLoadingButton(false);
    }
  };

  return (
    <Layout>
      <div style={{ display: "flex" }}>
        <Col md={12}>
          <h2 style={{ color: "black", fontSize: 20, marginTop: 10 }}>
            Thêm mới phòng ban
          </h2>
        </Col>
      </div>
      <Card>
        <Form
          className="form-container wrapper-content-inner"
          layout="vertical"
          form={form}
          name="phongban-control"
          onFieldsChange={() => setFieldTouch(true)}
        >
          <Row gutter={24}>
            <Col md={8} xs={24}>
              <FormItem
                layout="vertical"
                label={
                  <span>
                    Tên đơn vị/Phòng ban
                  </span>
                }
                name={["phongban", "tenDonVi"]}
                rules={[
                  {
                    type: "string",
                    required: true,
                    message: messages.ERROR_REQUIRED,
                  },
                ]}
                initialValue={tenDonVi}
              >
                <Input
                  name="tenDonVi"
                  className="input-item"
                  placeholder="Nhập tên phòng ban"
                />
              </FormItem>
            </Col>
            <Col md={12} xs={24}>
              <FormItem
                layout="vertical"
                name={["phongban", "parentId"]}
                label={
                  <span>
                    Thuộc đơn vị :<i className="color-required">*</i>
                  </span>
                }
                initialValue={parentId}
                rules={[
                  {
                    required: true,
                    message: "Vui lòng nhập chọn Đơn vị",
                  },
                ]}
              >
                <TreeSelect
                  allowClear
                  showSearch
                  // name="parentId"
                  treeDefaultExpandAll={false}
                  placeholder="Vui lòng chọn"
                  onChange={(e) => setParentId(e)}
                  treeData={treeDataSelect}
                  treeNodeFilterProp="title"
                  style={{ width: "100%" }}
                  dropdownStyle={{ overflow: "auto" }}
                />
              </FormItem>
            </Col>
            <Col md={8} xs={24}>
              <FormItem
                label="Loại đơn vị :"
                name={["phongban", "cap"]}
                initialValue={cap}
              >
                <Select
                  // name="cap"
                  onChange={(e) => setCap(e)}
                  placeholder="Chọn loại đơn vị"
                  style={{ width: "100%" }}
                  options={listCap}
                  fieldNames={{ label: "name", value: "cap" }}
                ></Select>
              </FormItem>
            </Col>
            <Col md={8} xs={24}>
              <FormItem
                label="Thứ tự :"
                name={["phongban", "thuTu"]}
                initialValue={thuTu}
              >
                <Input name="thuTu" placeholder="Thứ tự" type="number" />
              </FormItem>
            </Col>
            <Col md={8} xs={24}>
              <FormItem
                label={
                  <span>
                    Mã định danh
                  </span>
                }
                name={["phongban", "maDinhDanh"]}
                initialValue={maDinhDanh}
                rules={[
                  {
                    type: "string",
                    required: true,
                    message: "Vui lòng nhập mã định Danh",
                  },
                ]}
              >
                <Input
                  name="maDinhDanh"
                  placeholder="Mã định danh"
                  className="input-item"
                />
              </FormItem>
            </Col>
            <Col md={8} xs={24}>
              <FormItem
                label="Đơn vị"
                name={["phongban", "isDonVi"]}
                valuePropName="checked"
                initialValue={isDonVi}
              >
                <Switch />
              </FormItem>
            </Col>
          </Row>
          <hr/>
          <FormActionButton
            goBack={goBack}
            saveAndClose={saveAndClose}
            disabled={fieldTouch}
            save={save}
            loadingButton={loadingButton}
            loadingButtonClose={loadingButtonClose}
          />
        </Form>
      </Card>
    </Layout>
  );
};

export default PhongBanTableForm;
